import React from 'react';

const TabContext = React.createContext({
    activeId: undefined,
    onChange() {},
});

export default TabContext;
